import React from 'react';
import {Field, FieldArray, reduxForm, stopSubmit, stopAsyncValidation, startAsyncValidation} from 'redux-form'
import Divider from 'material-ui/Divider';
import Paper from 'material-ui/Paper';

import moment from 'moment'

import DeleteIcon from 'material-ui/svg-icons/action/delete';
import DoneIcon from 'material-ui/svg-icons/action/done';
import PersonIcon from 'material-ui/svg-icons/social/person';
import ForwardIcon from 'material-ui/svg-icons/content/forward';
import ReplyIcon from 'material-ui/svg-icons/content/reply';

import FlatButton from 'material-ui/FlatButton';
import * as colors from 'material-ui/styles/colors';

import CostCard from '../../components/CostCard'

import YosanBasicForm from './YosanBasicForm'
import YosanTransactionAmountForm from './YosanTransactionAmountForm'
import FormLabel from '../../components/FormLabel'
import FormAutoComplete2 from '../../components/FormAutoComplete2'
import FormDatePicker from '../../components/FormDatePicker'
import FormText from '../../components/FormText'
import FormCostContents from '../../components/FormCostContents'
import FormOrderAmmounts from '../../components/FormOrderAmmounts'
import FormClaimAmmounts from '../../components/FormClaimAmmounts'
import FormAmmountTotalLabel from '../../components/FormAmmountTotalLabel'
import YosanLeaner from '../../components/YosanLeaner'
import * as commons from '../../commons';
import * as actions from '../../actions';
import styles from '../../styles'

import Decimal from 'decimal.js'
import _ from 'lodash'
import $ from 'jquery'

const validateCosts = (costs, selectType, isUniq) => {


    if (!costs || !costs.length) {
        return []
    }

    const costsErrros = []
    const costsItems = []
    costs.forEach((cost, index) => {
        const error = {}
        if (cost.budget && !commons.validateNumber(cost.budget)) {
            error.budget = '数値入力を入力して下さい。'
        }
        if (cost.result && !commons.validateNumber(cost.result)) {
            error.result = '数値入力を入力して下さい。'
        }
        // if (!cost.budget && cost.result) {
        //   error.result = '予算が未入力です。'
        // }
        const costItem = cost[selectType];
        if (!costItem) {
            if (cost.budget || cost.result) {
                error[selectType] = '必須入力'
            }
        }
        if (isUniq) {
            if (costsItems.includes(costItem)) {
                error[selectType] = '重複した項目は登録できません。'
            }
        }
        costsItems.push(costItem);
        costsErrros[index] = error
    })

    return costsErrros

}

const validateOrderAmmount = (ammounts) => {

    if (!ammounts || !ammounts.length) {
        return []
    }

    const ammountErrors = []
    ammounts.forEach((ammount, index) => {
        const error = {}
        if (ammount.orderAmmount && !commons.validateNumber(ammount.orderAmmount)) {
            error.orderAmmount = '数値入力を入力して下さい。'
        }
        if (ammount.orderAmmountBudget && !commons.validateNumber(ammount.orderAmmountBudget)) {
            error.orderAmmountBudget = '数値入力を入力して下さい。'
        }
        ammountErrors[index] = error
    })

    return ammountErrors

}

const validateClaimAmmount = (ammounts) => {

    if (!ammounts || !ammounts.length) {
        return []
    }

    const ammountErrors = []
    ammounts.forEach((ammount, index) => {
        const error = {}
        if (ammount.claimAmmount && !ammount.year) {
            error.year = '必須入力'
        }
        if (ammount.claimAmmount && !ammount.month) {
            error.month = '必須入力'
        }
        if (ammount.claimAmmount && !commons.validateNumber(ammount.claimAmmount)) {
            error.claimAmmount = '数値入力を入力して下さい。'
        }
        ammountErrors[index] = error
    })

    return ammountErrors

}

const validate = values => {
    const errors = {}

    const requiredFields = [
        "kenmeiCode",
        "user",
        "startDate",
        "endDate",
    ]
    requiredFields.forEach(field => {
        if (!values[field]) {
            errors[field] = '必須入力'
        }
    })

    if (values.startDate && values.endDate) {
        if (moment(values.startDate).unix() > moment(values.endDate).unix()) {
            errors.startDate = '期間が不正です。'
            errors.endDate = '期間が不正です。'
        }
    }

    if (values.estimateAmmount && !commons.validateNumber(values.estimateAmmount)) {
        errors.estimateAmmount = '数値入力を入力して下さい。'
    }

    if (values.orderAmmount && !commons.validateNumber(values.orderAmmount)) {
        errors.orderAmmount = '数値入力を入力して下さい。'
    }

    if (values.orderAmmountBudget && !commons.validateNumber(values.orderAmmountBudget)) {
        errors.orderAmmountBudget = '数値入力を入力して下さい。'
    }

    if (values.claimAmmount && !commons.validateNumber(values.claimAmmount)) {
        errors.claimAmmount = '数値入力を入力して下さい。'
    }

    const orderAmmountErrors = validateOrderAmmount(values.orderAmmounts)
    if (orderAmmountErrors.length) {
        errors.orderAmmounts = orderAmmountErrors
    }

    const claimAmmountErrors = validateClaimAmmount(values.claimAmmounts)
    if (claimAmmountErrors.length) {
        errors.claimAmmounts = claimAmmountErrors
    }

    const materialCostsErrors = validateCosts(values.materialCosts, 'costId')
    if (materialCostsErrors.length) {
        errors.materialCosts = materialCostsErrors
    }

    const outsourcingCostsErrors = validateCosts(values.outsourcingCosts, 'costName', true)
    if (outsourcingCostsErrors.length) {
        errors.outsourcingCosts = outsourcingCostsErrors
    }

    const roumuCostsErrors = validateCosts(values.roumuCosts, 'costId')
    if (roumuCostsErrors.length) {
        errors.roumuCosts = roumuCostsErrors
    }

    const expenseCostsErrors = validateCosts(values.expenseCosts, 'costId')
    if (expenseCostsErrors.length) {
        errors.expenseCosts = expenseCostsErrors
    }

    return errors
}

const dataSourceConfig = {
    text: 'textKey',
    value: 'valueKey',
};


const flatCost = (historys) => {
    if (!historys) {
        return null
    }
    let result = []
    historys.forEach(x => {
        result = result.concat(x.data)
    })
    return result
}

class YosanFormPage extends React.Component {

    constructor(props) {
        super(props)
    }

    test() {

        this.props.dispatch(startAsyncValidation(`yosanForm`))
        const errors = {}
        const historyErrors = [];
        historyErrors[0] = {data: []}
        historyErrors[0].data[0] = {budget :'test'}

        // errors.materialCostHistorys = historyErrors;
        errors.user = "test";

        window.alert("test1")
        this.props.dispatch(stopAsyncValidation(`yosanForm`, errors))

    }

    handleNewRequest = (value, index) => {

        const {
            onKenmeiChange,
            kenmeiData
        } = this.props

        if (index === -1) {
            return
        }

        const kenmei = kenmeiData[index] || {}

        onKenmeiChange(
            {
                kenmeiName: kenmei.name,
                branchOfficeName: kenmei.branchOfficeName,
                departmentName: kenmei.departmentName,
                customerName: kenmei.customerName,
                constructionName: kenmei.constructionName,
                address: kenmei.address,
            }
        )

    }

    handleUpdateInput = (value) => {

        const {
            onKenmeiChange,
            kenmeiData
        } = this.props

        const kenmei = kenmeiData.find(x => {
            return x.code == value
        })

        if (kenmei) {
            onKenmeiChange(
                {
                    kenmeiName: kenmei.name,
                    branchOfficeName: kenmei.branchOfficeName,
                    departmentName: kenmei.departmentName,
                    customerName: kenmei.customerName,
                    constructionName: kenmei.constructionName,
                    address: kenmei.address,
                }
            )
        } else {
            onKenmeiChange(
                {
                    kenmeiName: "ー",
                    branchOfficeName: "ー",
                    departmentName: "ー",
                    customerName: "ー",
                    constructionName: "ー",
                    address: "ー",
                }
            )
        }

    }

    reduceAdd = (array, col) => {
        let num = 0
        if (array && array.length) {
            num = array.map(x => commons.toNumber(x[col])).reduce((a, b) => a + b)
        }
        return num
    }

    getOrderAmmount = (orderAmmount, orderAmmounts, col) => {
        return commons.toNumber(orderAmmount) + this.reduceAdd(orderAmmounts, col)
    }

    getAllBudget = (materialCosts, outsourcingCosts, roumuCosts, expenseCosts, materialCostHistorys, outsourcingCostHistorys, expenseCostHistorys) => {
        return this.reduceAdd(materialCosts, 'budget') +
            this.reduceAdd(outsourcingCosts, 'budget') +
            this.reduceAdd(roumuCosts, 'budget') +
            this.reduceAdd(expenseCosts, 'budget') +
            this.reduceAdd(materialCostHistorys, 'budget') +
            this.reduceAdd(outsourcingCostHistorys, 'budget') +
            this.reduceAdd(expenseCostHistorys, 'budget')
    }

    getAllResult = (materialCosts, outsourcingCosts, roumuCosts, xronosRoumuCosts, expenseCosts, materialCostHistorys, outsourcingCostHistorys, expenseCostHistorys) => {
        return this.reduceAdd(materialCosts, 'result') +
            this.reduceAdd(outsourcingCosts, 'result') +
            this.reduceAdd(roumuCosts, 'result') +
            this.reduceAdd(xronosRoumuCosts, 'result') +
            this.reduceAdd(expenseCosts, 'result') +
            this.reduceAdd(materialCostHistorys, 'result') +
            this.reduceAdd(outsourcingCostHistorys, 'result') +
            this.reduceAdd(expenseCostHistorys, 'result')
    }

    render() {

        const {
            auth,
            status,
            kenmeiData = [],
            userData = [],
            costData,
            materialCosts,
            outsourcingCosts,
            roumuCosts,
            xronosRoumuCosts,
            expenseCosts,
            orderAmmounts,
            orderAmmount,
            orderAmmountBudget,
            kenmeiNames,
            claimAmmounts,
            claimAmmount,
            error,
            initialValues,
            handleSubmit,
            onFormRegistClick,
            onFormDeleteClick,
            onFormStatusClick,

            materialCostHistorys,
            roumuCostHistorys,
            xronosRoumuCostHistorys,
            outsourcingCostHistorys,
            expenseCostHistorys,
            onKenmeiChange,
            dispatch,
            valid,
            isHistory,
            startDate,
            endDate
        } = this.props

        const materialCostDataSource = costData ? costData.filter(x => x.kind === 1) : []
        const outsourcingDataSource = costData ? costData.filter(x => x.kind === 2).map(x => ({
            textKey: x.name,
            valueKey: x.name
        })) : []
        const roumuDataSource = costData ? costData.filter(x => x.kind === 3) : []
        const expenseDataSource = costData ? costData.filter(x => x.kind === 4) : []

        const allOrderAmmount = this.getOrderAmmount(orderAmmount, orderAmmounts, 'orderAmmount')
        const allOrderAmmountBudget = this.getOrderAmmount(orderAmmountBudget, orderAmmounts, 'orderAmmountBudget')
        const allClaimAmmount = this.getOrderAmmount(claimAmmount, claimAmmounts, 'claimAmmount')

        const allBudget = this.getAllBudget(
            materialCosts,
            outsourcingCosts,
            roumuCosts,
            expenseCosts,
            flatCost(materialCostHistorys),
            flatCost(outsourcingCostHistorys),
            flatCost(expenseCostHistorys),
        )

        const allResult = this.getAllResult(
            materialCosts,
            outsourcingCosts,
            roumuCosts,
            xronosRoumuCosts,
            expenseCosts,
            flatCost(materialCostHistorys),
            flatCost(outsourcingCostHistorys),
            flatCost(expenseCostHistorys),
        )

        return (

            <form onSubmit={() => {
            }}>

                {error && <div><span style={{color: 'rgb(244, 67, 54)'}}>{error}</span></div>}

                <YosanBasicForm
                    kenmeiData={kenmeiData}
                    onKenmeiChange={onKenmeiChange}
                    userData={userData}
                    kenmeiNames={kenmeiNames}
                    status={status}/>

                <YosanTransactionAmountForm
                    orderOpen={_.isEmpty(orderAmmounts) ? true : false}
                    claimOpen={_.isEmpty(claimAmmounts) ? true : false}
                    allOrderAmmount={allOrderAmmount}
                    allOrderAmmountBudget={allOrderAmmountBudget}
                    allClaimAmmount={allClaimAmmount}
                    auth={auth}
                    status={status}/>

                <div className="row" style={{marginBottom: 30}}>
                    <div className="col">
                        <Divider/>
                    </div>
                </div>

                <div className="row" style={{marginBottom: 30}}>

                    <div className="col-4">
                        <Paper style={styles.yosanContents}>

                            <h4 style={styles.yosanFormTitle}>利益 (予算)</h4>

                            <Divider/>

                            <FormAmmountTotalLabel title='受注金額' total={allOrderAmmountBudget}/>
                            <FormAmmountTotalLabel title='費用' total={allBudget}/>
                            <FormAmmountTotalLabel title='粗利益'
                                                   total={
                                                       allOrderAmmountBudget === 0 ? 'ー' :
                                                           allOrderAmmountBudget - allBudget
                                                   }
                                                   color
                            />
                            <FormAmmountTotalLabel title='粗利益率'
                                                   total={
                                                       allOrderAmmountBudget === 0 ? 'ー' :
                                                           Math.floor((allOrderAmmountBudget - allBudget) / allOrderAmmountBudget * 100)
                                                   }
                                                   addContents={
                                                       allOrderAmmountBudget === 0 ? '' :
                                                           (<span style={{
                                                               fontSize: 20,
                                                               color: colors.grey600
                                                           }}>&nbsp;%</span>)
                                                   }
                                                   color
                            />

                        </Paper>
                    </div>

                    <div className="col-4">

                        <Paper style={styles.yosanContents}>

                            <h4 style={styles.yosanFormTitle}>利益 (受注)</h4>

                            <Divider/>

                            <FormAmmountTotalLabel title='受注金額' total={allOrderAmmount}/>
                            <FormAmmountTotalLabel title='費用' total={allResult}/>
                            <FormAmmountTotalLabel title='粗利益'
                                                   total={
                                                       allOrderAmmount === 0 ? 'ー' :
                                                           allOrderAmmount - allResult
                                                   }
                                                   color
                            />
                            <FormAmmountTotalLabel title='粗利益率'
                                                   total={
                                                       allOrderAmmount === 0 ? 'ー' :
                                                           Math.floor(new Decimal(allOrderAmmount - allResult).div(allOrderAmmount).times(100).toNumber())
                                                   }
                                                   addContents={
                                                       allOrderAmmount === 0 ? '' :
                                                           (<span style={{
                                                               fontSize: 20,
                                                               color: colors.grey600
                                                           }}>&nbsp;%</span>)
                                                   }
                                                   color
                            />

                            <FormAmmountTotalLabel title='達成率'
                                                   total={
                                                       allOrderAmmountBudget == 0 || allOrderAmmount == 0
                                                           ? 'ー' :
                                                           Math.floor(new Decimal(allOrderAmmount - allResult).div(allOrderAmmountBudget - allBudget).times(100).toNumber())
                                                   }
                                                   addContents={
                                                       allOrderAmmountBudget == 0 || allOrderAmmount == 0
                                                           ? '' :
                                                           (<span style={{
                                                               fontSize: 20,
                                                               color: colors.grey600
                                                           }}>&nbsp;%</span>)
                                                   }
                                                   color
                            />

                        </Paper>
                    </div>


                    <div className="col-4">

                        <Paper style={styles.yosanContents}>

                            <h4 style={styles.yosanFormTitle}>利益 (請求)</h4>

                            <Divider/>

                            <FormAmmountTotalLabel title='請求金額' total={allClaimAmmount}/>
                            <FormAmmountTotalLabel title='費用' total={allResult}/>
                            <FormAmmountTotalLabel title='粗利益'
                                                   total={
                                                       allClaimAmmount === 0 ? 'ー' :
                                                           allClaimAmmount - allResult
                                                   }
                                                   color
                            />
                            <FormAmmountTotalLabel title='粗利益率'
                                                   total={
                                                       allClaimAmmount === 0 ? 'ー' :
                                                           Math.floor(new Decimal(allClaimAmmount - allResult).div(allClaimAmmount).times(100).toNumber())
                                                   }
                                                   addContents={
                                                       allClaimAmmount === 0 ? '' :
                                                           (<span style={{
                                                               fontSize: 20,
                                                               color: colors.grey600
                                                           }}>&nbsp;%</span>)
                                                   }
                                                   color
                            />

                            <FormAmmountTotalLabel title='達成率'
                                                   total={
                                                       allOrderAmmountBudget == 0 || allClaimAmmount == 0
                                                           ? 'ー' :
                                                           Math.floor(new Decimal(allClaimAmmount - allResult).div(allOrderAmmountBudget - allBudget).times(100).toNumber())
                                                   }
                                                   addContents={
                                                       allOrderAmmountBudget == 0 || allClaimAmmount == 0
                                                           ? '' :
                                                           (<span style={{
                                                               fontSize: 20,
                                                               color: colors.grey600
                                                           }}>&nbsp;%</span>)
                                                   }
                                                   color
                            />

                        </Paper>
                    </div>

                </div>

                <div className="row" style={{marginBottom: 30}}>
                    <div className="col">
                        <Divider/>
                    </div>
                </div>

                <div className="row" style={{marginBottom: 30}}>
                    <div className="col">

                        <CostCard
                            key={1}
                            kind={'材料費'}
                            name={'materialCostHistorys'}
                            monthCosts={materialCostHistorys}
                            dataSourceType='select'
                            dataSource={materialCostDataSource}
                            status={status}
                            dispatch={dispatch}
                            newCosts={materialCosts}
                            newCostName={'materialCosts'}
                            isNew={!initialValues.id ? true : false}
                        />
                    </div>
                </div>


                <div className="row" style={{marginBottom: 30}}>
                    <div className="col">

                        <CostCard
                            key={2}
                            kind={'外注費'}
                            name={'outsourcingCostHistorys'}
                            monthCosts={outsourcingCostHistorys}
                            dataSourceType='autoComplete'
                            dataSource={outsourcingDataSource}
                            status={status}
                            dispatch={dispatch}
                            newCosts={outsourcingCosts}
                            newCostName={'outsourcingCosts'}
                            isNew={!initialValues.id ? true : false}
                        />
                    </div>
                </div>

                <div className="row" style={{marginBottom: 30}}>
                    <div className="col">

                        <CostCard
                            key={3}
                            kind={'労務費'}
                            name={'roumuCostHistorys'}
                            monthCosts={roumuCostHistorys}
                            dataSourceType='select'
                            dataSource={roumuDataSource}
                            status={status}
                            dispatch={dispatch}
                            newCosts={roumuCosts}
                            newCostName={'roumuCosts'}
                            resultDisable
                            isNew={!initialValues.id ? true : false}
                            startDate={startDate}
                            endDate={endDate}
                        />
                    </div>
                </div>

                {
                    initialValues.id && 
                    <div className="row" style={{marginBottom: 30}}>
                    <div className="col">

                        <CostCard
                            key={3}
                            kind={'労務費（外部サイト連携）'}
                            name={'xronosRoumuCostHistorys'}
                            monthCosts={xronosRoumuCostHistorys}
                            dataSourceType='select'
                            dataSource={roumuDataSource}
                            status={status}
                            dispatch={dispatch}
                            newCosts={xronosRoumuCosts}
                            newCostName={'xronosRoumuCosts'}
                            resultDisable
                            isNew={!initialValues.id ? true : false}
                            startDate={startDate}
                            endDate={endDate}
                        />
                    </div>
                    </div>
                }

                <div className="row" style={{marginBottom: 30}}>
                    <div className="col">

                        <CostCard
                            key={4}
                            kind={'経費'}
                            name={'expenseCostHistorys'}
                            monthCosts={expenseCostHistorys}
                            dataSourceType='select'
                            dataSource={expenseDataSource}
                            status={status}
                            dispatch={dispatch}
                            newCosts={expenseCosts}
                            newCostName={'expenseCosts'}
                            isNew={!initialValues.id ? true : false}
                        />
                    </div>
                </div>

                {/*<div className="row" style={{marginBottom: 30}}>*/}
                {/*<div className="col">*/}
                {/*<Paper style={styles.yosanContents}>*/}

                {/*<h4 style={styles.yosanFormTitle}>材料費</h4>*/}

                {/*<Divider style={{marginBottom: 10}}/>*/}

                {/*<FieldArray name="materialCosts" org={materialCosts} component={FormCostContents}*/}
                {/*dataSourceType='select' dataSource={materialCostDataSource} status={status}/>*/}

                {/*<YosanLeaner costs={materialCosts}/>*/}

                {/*</Paper>*/}
                {/*</div>*/}
                {/*</div>*/}

                {/*<div className="row" style={{marginBottom: 30}}>*/}
                {/*<div className="col">*/}
                {/*<Paper style={styles.yosanContents}>*/}

                {/*<h4 style={styles.yosanFormTitle}>外注費</h4>*/}

                {/*<Divider style={{marginBottom: 10}}/>*/}

                {/*<FieldArray name="outsourcingCosts" org={outsourcingCosts} component={FormCostContents}*/}
                {/*dataSourceType='autoComplete' dataSource={outsourcingDataSource}*/}
                {/*dataSourceConfig={dataSourceConfig} status={status}/>*/}

                {/*<YosanLeaner costs={outsourcingCosts}/>*/}

                {/*</Paper>*/}
                {/*</div>*/}
                {/*</div>*/}

                {/*<div className="row" style={{marginBottom: 30}}>*/}
                {/*<div className="col">*/}
                {/*<Paper style={styles.yosanContents}>*/}

                {/*<h4 style={styles.yosanFormTitle}>労務</h4>*/}

                {/*<Divider style={{marginBottom: 10}}/>*/}

                {/*<FieldArray name="roumuCosts" org={roumuCosts} component={FormCostContents}*/}
                {/*dataSourceType='select' dataSource={roumuDataSource} status={status}*/}
                {/*resultDisable/>*/}

                {/*<YosanLeaner costs={roumuCosts}/>*/}

                {/*</Paper>*/}
                {/*</div>*/}
                {/*</div>*/}

                {/*<div className="row" style={{marginBottom: 30}}>*/}
                {/*<div className="col">*/}
                {/*<Paper style={styles.yosanContents}>*/}

                {/*<h4 style={styles.yosanFormTitle}>経費</h4>*/}

                {/*<Divider style={{marginBottom: 10}}/>*/}

                {/*<FieldArray name="expenseCosts" org={expenseCosts} component={FormCostContents}*/}
                {/*dataSourceType='select' dataSource={expenseDataSource} status={status}/>*/}

                {/*<YosanLeaner costs={expenseCosts}/>*/}

                {/*</Paper>*/}
                {/*</div>*/}
                {/*</div>*/}

                {

                    !isHistory &&
                    (

                        <div className="row" style={{textAlign: 'right'}}>
                            <div className="col">
                                {/*<div style={styles.buttons}>*/}

                                {
                                    initialValues.id &&
                                    <FlatButton
                                        label="削除"
                                        labelPosition="before"
                                        primary={true}
                                        labelStyle={{color: colors.white, lineHeight: '40px'}}
                                        style={{height: '40px', width: '100px', marginRight: '20px'}}
                                        backgroundColor={colors.grey600}
                                        hoverColor={colors.grey800}
                                        icon={<DeleteIcon color={colors.white}/>}
                                        onClick={handleSubmit(onFormDeleteClick(initialValues.id))}
                                    />
                                }

                                {
                                    auth.user.permission == 2 && status === 3 &&
                                    <FlatButton
                                        label="ステータス戻し"
                                        labelPosition="before"
                                        primary={true}
                                        labelStyle={{color: colors.white, lineHeight: '40px'}}
                                        style={{height: '40px', width: '160px', marginRight: '20px'}}
                                        backgroundColor={colors.grey600}
                                        hoverColor={colors.grey800}
                                        icon={<ReplyIcon color={colors.white}/>}
                                        onClick={handleSubmit(onFormStatusClick(initialValues.id, "REVERSE"))}
                                    />
                                }

                                {
                                    auth.user.permission == 2 && status === 2 &&
                                    <FlatButton
                                        label="完工"
                                        labelPosition="before"
                                        primary={true}
                                        labelStyle={{color: colors.white, lineHeight: '40px'}}
                                        style={{height: '40px', width: '100px', marginRight: '20px'}}
                                        backgroundColor={colors.grey600}
                                        hoverColor={colors.grey800}
                                        icon={<ForwardIcon color={colors.white}/>}
                                        onClick={handleSubmit(onFormStatusClick(initialValues.id, "END"))}
                                    />
                                }

                                {
                                    auth.user.permission == 2 && status === 1 &&
                                    <FlatButton
                                        label="着工"
                                        labelPosition="before"
                                        primary={true}
                                        labelStyle={{color: colors.white, lineHeight: '40px'}}
                                        style={{height: '40px', width: '100px', marginRight: '20px'}}
                                        backgroundColor={colors.grey600}
                                        hoverColor={colors.grey800}
                                        icon={<ForwardIcon color={colors.white}/>}
                                        onClick={handleSubmit(onFormStatusClick(initialValues.id, "START"))}
                                    />
                                }

                                {
                                    auth.user.permission == 2 && status === 0 &&
                                    <FlatButton
                                        label="承認"
                                        labelPosition="before"
                                        primary={true}
                                        labelStyle={{color: colors.white, lineHeight: '40px'}}
                                        style={{height: '40px', width: '100px', marginRight: '20px'}}
                                        backgroundColor={colors.grey600}
                                        hoverColor={colors.grey800}
                                        icon={<PersonIcon color={colors.red400}/>}
                                        onClick={handleSubmit(onFormStatusClick(initialValues.id, "APPROVAL"))}
                                    />
                                }

                                {
                                    status !== 3 &&
                                    <FlatButton
                                        label="登録"
                                        labelPosition="before"
                                        primary={true}
                                        labelStyle={{color: colors.white, lineHeight: '40px'}}
                                        style={{height: '40px', width: '100px'}}
                                        backgroundColor={colors.cyan700}
                                        hoverColor={colors.cyan900}
                                        icon={<DoneIcon color={colors.white}/>}
                                        onClick={handleSubmit(onFormRegistClick(initialValues.id, startDate, endDate))}
                                    />
                                }

                            </div>
                        </div>
                    )
                }

            </form>
        );
    }
};

YosanFormPage = reduxForm({
    form: 'yosanForm', // a unique identifier for this form
    enableReinitialize: true,
    validate,
    onSubmitFail: (errors, dispatch) => {
        dispatch(actions.reducerSnackBar(true, '入力内容に誤りがあります。', colors.red400))
    }
})(YosanFormPage)

export default YosanFormPage


// WEBPACK FOOTER //
// ./src/containers/yosan/YosanForm.js